// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

export const TEAMS_FEATURE_ENV_KEY = "VITE_FEATURES_TEAMS";
